import { Component } from '@angular/core';
import { AuthService } from '../../../guards/services/auth.service';
import { UserItem } from '../../../api/models';
import { MenuItem } from 'primeng/api';

interface ChatMessage {
  text: string;
  when: string;
  user_id: number;
}

@Component({
  selector: 'app-user-leads-single',
  templateUrl: './user-leads-single.component.html',
  styleUrl: './user-leads-single.component.scss',
})
export class UserLeadsSingleComponent {
  user?: UserItem;
  activeIndex = 0;
  chatMessages: ChatMessage[] = [
    {
      text: 'Ciao, sto pensando di organizzare un viaggio in Israele per la prossima estate. Potresti farmi un preventivo per 2 persone per una settimana?',
      when: '2025-10-14T10:00:00',
      user_id: 1,
    },
    {
      text: "Ciao! Certamente, posso aiutarti con il preventivo. Ti invio un'offerta con volo, hotel e escursioni. Ti arriverà tra poco.",
      when: '2025-10-14T10:15:00',
      user_id: 2,
    },
    {
      text: 'Perfetto, grazie! Aspetto il preventivo.',
      when: '2025-10-14T10:20:00',
      user_id: 1,
    },
    {
      text: 'Ecco il preventivo: volo + hotel 4 stelle per 2 persone: €3000, inclusi 3 escursioni guidate. Fammi sapere se hai domande!',
      when: '2025-10-14T10:35:00',
      user_id: 2,
    },
    {
      text: "Ciao, grazie per il preventivo! Però il costo mi sembra un po' alto, puoi modificare il tipo di hotel per ridurre il prezzo? Magari un 3 stelle, se possibile.",
      when: '2025-10-14T10:45:00',
      user_id: 1,
    },
    {
      text: "I prezzi sono un po' alti in quella stagione, provo a formulare un nuovo preventivo.",
      when: '2025-10-14T10:15:00',
      user_id: 2,
    },
    {
      text: 'Perfetto, quando è pronto puoi inviarmelo?',
      when: '2025-10-14T10:45:00',
      user_id: 1,
    },
  ].reverse();
  attachments_menu?: MenuItem[] = [
    { label: 'Primo preventivo', icon: 'pi pi-file-pdf' },
    { label: 'Secondo preventivo', icon: 'pi pi-file-pdf' },
    { label: 'Terzo preventivo', icon: 'pi pi-file-pdf' },
  ];
  files = [
    { label: "Primo preventivo", when: "" },
    { label: "Secondo preventivo", when: "" },
    { label: "Terzo preventivo", when: "" }
  ]

  constructor(public auth: AuthService) {
    this.user = auth.user.value;
  }
}
